import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import { createLowlight, common } from "lowlight";

// Official extension, ProseMirror-schema-native code block. Two things this is specifically
// meant to fix vs. today's hand-rolled version:
//  1. Enter inside the block should stay a plain newline by construction (ProseMirror's
//     code_block node type has no child inline structure to "split" the way a paragraph does)
//     — no custom keydown interception needed. Verify this live, don't assume it (see Milestone 2
//     checklist in the plan).
//  2. getHTML() emits real <pre><code> with literal "\n" text content (matching what
//     examHighlight.run() + QuestionContentRenderer's sanitizer already expect) rather than the
//     <br>-based structure that today's hljs.textContent bug came from.
const lowlight = createLowlight(common);

export const codeBlock = CodeBlockLowlight.configure({ lowlight });
